// product image slider 
function initializeSwiper() {
    var thumb = new Swiper(".single-product-thumb", {
        loop: true,
        spaceBetween: 6,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true, 
    });  

    var fetured = new Swiper(".single-product-featured", {
        loop: true,
        spaceBetween: 10,
        navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
        },
        thumbs: {
        	swiper: thumb,
        },
    });
}

$(document).ready(function(){
    initializeSwiper();

     // brands slider 
     var swiper = new Swiper('.brandSlide',{
        spaceBetween: 0,
        grabCursor: true,
        a11y: false,
        freeMode: true,
        speed: 10000,
        loop: true,
        slidesPerView: 6,
        autoplay: {
            delay: 0.5,
            disableOnInteraction: false,
        },
        breakpoints: {
            1: {
                slidesPerView: 2,
            },
            576: {
                slidesPerView: 3,
            },
            992: {
                slidesPerView: 6,
            }
        }
    });

    if($(window).width() > 768) {
        $('.image-tab-left-item').on('click', function(){
            var id = $(this).data('id');
            $('#image_tab_'+id).fadeIn().siblings().hide();
            $(this).addClass('active').siblings().removeClass('active');
        });
    }
    if($(window).width() < 768) {
        $('.tab-item-top').on('click', function(){
            $(this).next().slideToggle();
            $(this).parent().toggleClass('active').siblings().removeClass('active').find('.tab-body-mobile').slideUp();
        });
    }

    $('.accordion-item-title').on('click', function(){
        $(this).next().slideToggle();
        $(this).parent().toggleClass('active');
    });

    $(document).on('click', '.single-product-accordion-item-title', function() {
        $(this).next().slideToggle();
        $(this).parent().toggleClass('active').siblings().find('.single-product-accordion-item-content').slideUp();
    });

    
})


// video player js start....
new VenoBox({
	selector: '.video-play-btn',
});


// new js 

$(document).ready(function () {
	'use strict';
	// navbar js start ---
	$(window).on('load scroll', function () {
		var scrolling = $(this).scrollTop();
		if (scrolling > 10) {
			$('.navbar').addClass('nav-fixed')
		} else {
			$('.navbar').removeClass('nav-fixed')
		}
	})

	$(".ham-menu").click(function (event) {
		event.stopPropagation();
		$(".sidebar-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".sidebar-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".mobile-menu-close-window-btn").click(function (event) {
		event.stopPropagation();
		$(".sidebar-wrapper").toggleClass("active");
		$(".ham-menu").toggleClass("active");
		$(".sidebar-wrapper-inner").toggleClass("active");
		$("body").toggleClass("active");
	});

	// **..mobile-dropdown-accordion js start..**
	$('.sidebar-submenu-open').on('click', function () {
		$(this).parent().find(".megamenu-wrapper").addClass('active');
	});

	$('.sidebar-close-btn').on('click', function () {
		$(this).parent().parent(".megamenu-wrapper").removeClass('active');
	});

	$('.megamenu-heading').on('click', function () {
		$(this).toggleClass('active').next().slideToggle();
	});
	// **..mobile-dropdown-accordion js end..**

	$(".search-bar-open-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".search-bar-window-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(this).toggleClass("active");
		$("body").toggleClass("active");
	});

	$(".search-close-btn").click(function (event) {
		event.stopPropagation();
		$(".search-bar").toggleClass("active");
		$(".search-bar-window-close-btn").toggleClass("active");
		$("body").toggleClass("active");
	});

	// navbar js end ---

})

// btn js ---
// primary btn---
$(function () {
	$('.primary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});

// secondary btn--
$(function () {
	$('.secondary-btn')
		.on('mouseenter', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		})
		.on('mouseout', function (e) {
			var parentOffset = $(this).offset(),
				relX = e.pageX - parentOffset.left,
				relY = e.pageY - parentOffset.top;
			$(this).find('span').css({
				top: relY,
				left: relX
			})
		});
});
// btn js ---

// product slider js start--
var swiper = new Swiper(".product-slider", {
	slidesPerView: 4,
	spaceBetween: 20,
	grabCursor: true,
	loop: true,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: '.product-slider-btn-next',
		prevEl: '.product-slider-btn-prev',
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			spaceBetween: 10,
			slidesPerView: 1.3,
		},
		// when window width is >= 768px
		576: {
			spaceBetween: 15,
			slidesPerView: 2.2,
		},
		// when window width is >= 993px
		993: {
			spaceBetween: 16,
			slidesPerView: 3,
		},
		// when window width is >= 1140x
		1140: {
			spaceBetween: 20,
			slidesPerView: 3,
		},
		// when window width is >= 1290px
		1290: {
			spaceBetween: 20,
			slidesPerView: 4,
		}
	}
});
// product slider js end--

// testimonial slider js start--
var swiper = new Swiper(".testimonial-slider", {
	slidesPerView: "auto",
	centeredSlides: true,
	spaceBetween: 20,
	grabCursor: true,
	loop: true,
	speed: 1000,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
	},
	navigation: {
		nextEl: '.product-slider-btn-next',
		prevEl: '.product-slider-btn-prev',
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			spaceBetween: 10,
			slidesPerView: 1,
			centeredSlides: false,
			speed: 500,

		},
		// when window width is >= 576px
		576: {
			spaceBetween: 15,
			centeredSlides: false,
			slidesPerView: 1.1,
			speed: 500,
		},
		// when window width is >= 767px
		767: {
			spaceBetween: 15,
			centeredSlides: false,
			slidesPerView: 1.5,
			speed: 500,
		},
		// when window width is >= 993px
		993: {
			spaceBetween: 16,
			centeredSlides: true,
			speed: 1000,
		},
	}
});
// testimonial slider js end--

var swiper = new Swiper('.swiper-container', {

    autoplay: {delay: 5000 },
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  // icon-item-slider js start--
var swiper = new Swiper(".icon-item-slider", {
	slidesPerView: 2.4,
	spaceBetween: 20,
	grabCursor: true,
	loop: true,
	navigation: {
		nextEl: '.icon-item-slider-btn-next',
		prevEl: '.icon-item-slider-btn-prev',
	},
	breakpoints: {
		// when window width is >= 320px
		1: {
			spaceBetween: 10,
			slidesPerView: 1.2,
		},
		// when window width is >= 768px
		576: {
			spaceBetween: 16,
			slidesPerView: 1.5,
		},
		// when window width is >= 993px
		993: {
			spaceBetween: 20,
			slidesPerView: 2.4,
		}
	}
});

// img-text-slider js start--


	var imgThumb = new Swiper(".img-text-thumb", {
        loop: true,
        spaceBetween: 6,
        slidesPerView: 6,
        freeMode: true,
        watchSlidesProgress: true, 
    });  

    var imgSlide = new Swiper(".img-text-slider", {
		slidesPerView: 1,
		spaceBetween: 0,
		grabCursor: true,
		autoHeight: true,
		loop: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		
        thumbs: {
        	swiper: imgThumb,
        },
    });
// img-text-slider js end--

 $(document).ready(function(){

	$('.product-varient-input').on('change', function(){
		var id = $(this).val();

		var selling_id = $('#selling_plan_1').data('id');
		var selling_id_2 = $('#selling_plan_2').data('id');
		var selling_id_3 = $('#selling_plan_3').data('id');

		if(id == 1) {
			$('.price-card-content').addClass('onetime').removeClass('subscription');
			$('.selling_plan').val('');
		}else{
			$('.price-card-content').addClass('subscription').removeClass('onetime');
			$('#selling_plan_1').val(selling_id);
			$('#selling_plan_2').val(selling_id_2);
			$('#selling_plan_3').val(selling_id_3);
		}
		
	})

	$(".addToCartPremium").on("click", function (e) {
		e.preventDefault();

		$.ajax({
			type: "POST",
			url: "/cart/add.js",
			data: $(this).parent().serialize(),
			dataType: "json",
			success: function (data) {
				// console.log(data);
				window.location.href = '/checkout'
			},
			error: function (err) {
				console.log("Error", err);
			},
		});
	});
 })

